import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=15a7b02a&"
import script from "./TableList.vue?vue&type=script&lang=ts&"
export * from "./TableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports